"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Helper function to check if a string is numeric
var isNumeric = function (str) { return /^\d+$/.test(str); };
var sortFacets = function (arr) {
    return arr.sort(function (a, b) {
        var facetNameA = a.split('--')[0];
        var facetNameB = b.split('--')[0];
        var isANumeric = isNumeric(facetNameA);
        var isBNumeric = isNumeric(facetNameB);
        // If one is numeric and the other is not, the numeric one is "greater"
        if (isANumeric && !isBNumeric)
            return 1;
        if (!isANumeric && isBNumeric)
            return -1;
        // If both are numeric or both are non-numeric, compare as strings
        return facetNameA.localeCompare(facetNameB);
    });
};
exports.default = sortFacets;
